import { render, staticRenderFns } from "./BloqueioLento.vue?vue&type=template&id=d978c83a"
import script from "./BloqueioLento.vue?vue&type=script&lang=js"
export * from "./BloqueioLento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports